import { Skeleton } from "@mui/material";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJobs, updateLoadJobKey } from "../../../redux/actions/job_action";
import {
  BackIcon,
  EmptyContainer,
  IconButtonStyled,
  NextIcon,
  TypographyGreyStyled,
  TypographyStyled,
  Wrapper,
} from "./styles";

const Pagination = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector((state) => state.jobs.jobCurrentPage);
  const jobPageInfo = useSelector((state) => state.jobs.jobPageInfo);
  const jobParams = useSelector((state) => state.jobs.jobsParams);
  const fetchingAllJobs = useSelector((state) => state.jobs.fetchingAllJobs);

  const previousPage = () => {
    const loadJobKey = moment().format("dd/mm/yyyy hh:mm:ss");
    const paginationBack = {
      first: null,
      last: 30,
      startCursor: jobPageInfo?.startCursor,
      endCursor: null,
    };

    dispatch(updateLoadJobKey(loadJobKey)).then(() => {
      const params = {
        ...jobParams,
        loadJobKey: loadJobKey,
      };

      dispatch(getJobs(params, paginationBack, false, true));
    });

    scrollTo(0, 0);
  };

  const nextPage = () => {
    const loadJobKey = moment().format("dd/mm/yyyy hh:mm:ss");
    const paginationNext = {
      first: null,
      last: null,
      startCursor: null,
      endCursor: jobPageInfo?.endCursor,
    };

    dispatch(updateLoadJobKey(loadJobKey)).then(() => {
      const params = {
        ...jobParams,
        loadJobKey: loadJobKey,
      };

      dispatch(getJobs(params, paginationNext, true, false));
    });

    scrollTo(0, 0);
  };

  return (
    <Wrapper container justifyContent="center" alignItems="center">
      {fetchingAllJobs ? (
        <Skeleton
          variant="rounded"
          style={{ width: "200px", height: "30px" }}
        />
      ) : (
        <EmptyContainer
          container
          width="auto"
          flexDirection="row"
          alignItems="center"
          gap="15px"
        >
          {/* Back */}
          {jobPageInfo?.hasPreviousPage && (
            <IconButtonStyled onClick={previousPage}>
              <BackIcon />
            </IconButtonStyled>
          )}

          <EmptyContainer
            container
            width="auto"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            gap="25px"
          >
            {/* Previous Page Number */}
            {currentPage - 1 !== 0 && (
              <TypographyGreyStyled>{currentPage - 1}</TypographyGreyStyled>
            )}

            {/* Current Page Number */}
            <TypographyStyled>{currentPage}</TypographyStyled>

            {/* Next Page Number */}
            {jobPageInfo?.hasNextPage && (
              <TypographyGreyStyled>{currentPage + 1}</TypographyGreyStyled>
            )}
          </EmptyContainer>
          {/* Next */}

          {jobPageInfo?.hasNextPage && (
            <IconButtonStyled onClick={nextPage}>
              <NextIcon />
            </IconButtonStyled>
          )}
        </EmptyContainer>
      )}
    </Wrapper>
  );
};

export default Pagination;
